import type { DatabaseView } from '@databases/types/database/view';

type ViewNameSource = Pick<DatabaseView, 'id' | 'name'>;

type GetAllViewNamesOptions = {
  excludeViewId?: DatabaseView['id'];
};

/**
 * Returns persisted and pending view names for uniqueness checks.
 */
export const getAllViewNames = (
  savedViews: ViewNameSource[],
  pendingViewNames: Record<string, string>,
  options: GetAllViewNamesOptions = {}
): string[] => [
  ...savedViews
    .filter((view) => view.id !== options.excludeViewId)
    .map((view) => view.name),
  ...Object.entries(pendingViewNames)
    .filter(([viewId]) => viewId !== options.excludeViewId)
    .map(([, viewName]) => viewName)
];
